export default __webpack_public_path__ + "static/media/failure-purchase.222a2642.svg";